class AnimationComponent {
    constructor(from, to, duration = 1000) {
        this.typeId = AnimationComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.from = from;
        this.to = to;
        this.startTime = Date.now();
        this.duration = duration;
        this.endTime = this.startTime + duration;
        this.isAnimating = true;
    }
    eq() {
        return false;
    }
}
AnimationComponent.id = 2040;
export default AnimationComponent;
//# sourceMappingURL=AnimationComponent.js.map